import React, {createContext, useContext, useState, useRef} from "react"
import {transition_delay} from "./components/kenhub_modal"

const ModalContext = createContext()
export function use_modal() {
  return useContext(ModalContext)
}

function ModalProvider({children}) {
  const [active_modal, set_active_modal] = useState(null)
  const timeout_ref = useRef(null)

  function open_modal(modal_id) {
    if (!active_modal) {
      disable_scrolling()
      return set_active_modal(modal_id)
    }

    if (active_modal) close_modal()
    // Wait for finishing animation to complete, then open new modal
    timeout_ref.current = setTimeout(() => {
      disable_scrolling()
      set_active_modal(modal_id)
    }, transition_delay)
  }

  function close_modal() {
    enable_scrolling()
    set_active_modal(null)
    clearTimeout(timeout_ref.current)
  }

  return (
    <ModalContext.Provider value={{active_modal, open_modal, close_modal}}>
      {children}
    </ModalContext.Provider>
  )
}

function disable_scrolling() {
  const scrollbar_width =
    window.innerWidth - document.documentElement.clientWidth
  // react-modal provides the attribute bodyOpenClassName but we experienced
  // that it didn't  work reliable in all cases
  document.body.classList.add("modal-open")
  // prevents a flicker when the scrollbar disappears
  document.body.style.paddingRight = `${scrollbar_width}px`
}

function enable_scrolling() {
  document.body.classList.remove("modal-open")
  document.body.style.paddingRight = ""
}

export default ModalProvider
